// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"index__footer___DXB1w","back-link":"index__back-link___QV5UI","backLink":"index__back-link___QV5UI","icon":"index__icon___2clYK","delete-button":"index__delete-button___1vgDP","deleteButton":"index__delete-button___1vgDP"};
    if(module.hot) {
      // 1773631608493
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  